<template>
    <footer>
        <div class="grid-container reduced">
            <div class="grid">
                <div class="cell large-6 medium-12 small-12">
                    <Logo path="//realstaffing.com" :external="true"/>
                </div>
                <div class="cell large-3 medium-12 small-12">
                    <h4>Information</h4><hr/>
                    <ul class="info">
                        <li><a href="//realstaffing.com/en-gb/contact/" target="_blank">Contact</a></li>
                        <li><a href="">FAQ</a></li>
                        <li><a href="//realstaffing.com/en-gb/company-details/" target="_blank">Company Details</a></li>
                    </ul>
                </div>
                <div class="cell large-3 medium-12 small-12">
                    <h4>Legal</h4><hr/>
                    <ul class="legal">
                        <li><router-link v-bind:to="{path: '/Terms'}">Terms & Conditions</router-link></li>
                        <li><a href="//realstaffing.com/en-gb/privacy-and-cookie-policies/" target="_blank">Privacy & Cookie Poilicy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import Logo from '../../core/Logo';
    export default {
        name: 'Footer',
        components: {Logo},
        computed: {
        }
    };
</script>

<style scoped>
    
    footer {background: var(--colour-primary); padding: 3rem 0; margin-top: 2rem;}
    footer >>> .brand-logo {font-size: 1.5rem;}
    h4 {color: #fff;}
    ul {padding: 0; margin: 0; list-style: none;}
        ul > li {}
        ul > li + li {margin-top: .5rem;}
            ul > li > a {color: #fff;}
    
    @media screen and (max-width: 750px) {
        footer {text-align: center; padding: 2rem 0;}
        h4, hr {display: none;}
        ul.info {margin-top: 1rem;}
        ul.legal {margin-top: .75rem;}
    }
    
</style>